export default __webpack_public_path__ + "static/media/click.e0a22f25.svg";